import { useFormikContext } from "formik";
import React from "react";
import Button, { ButtonBase } from "./Button";


export default function Submit(props: ButtonBase) {
  const { submitForm, isSubmitting } = useFormikContext();

  return (
    <Button
      className="ms-auto"
      text="Save"
      icon="save"
      {...props}
      type="submit"
      onClick={() => submitForm()}
      loading={isSubmitting}
    />
  )
}